var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupportIcon = function SvgSupportIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.31571C0 1.93157 2.0286 0 4.5315 0H8.0685C10.5718 0 12.6 1.932 12.6 4.31571C12.6 6.69857 10.5714 8.631 8.0685 8.631H5.4V10.7143C5.4 10.7143 0 9.67286 0 4.31571Z",
    fill: "#1A50BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21465 9.37157C9.88909 9.98977 10.7891 10.3345 11.7252 10.3333H13.05V12C13.05 12 18 11.1669 18 6.88114C18 5.96554 17.6181 5.08743 16.9384 4.43996C16.2586 3.79249 15.3366 3.42869 14.3752 3.42857H13.3807C13.4586 3.70971 13.5 4.005 13.5 4.30971C13.5 6.79286 11.664 8.868 9.21465 9.37157Z",
    fill: "#1A50BA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/support-icon.ac55006db1dafef358e7f98d0c11d204.svg";